module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Menu button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Opens left navigation menu where you can skip book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("share")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Social share buttons")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book on your chousen social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change various visual settings")])]), _vm._v(" "), _c('div', {
    staticClass: "info-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa-info-circle")])], 1), _vm._v(" "), _c('div', {
    staticClass: "info-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Info button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Open or close informational screen")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate previous page or chapter in book view(on mobile screen just swipe right)")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("chevron_right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate next page or chapter in book view(on mobile screen just swipe left)")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://www.goodreads.com/book/show/22138137-mastering-the-craft-of-writing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("shopping_basket")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy books links")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Visit sellers shop to purchace this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "clipped": "",
      "temporary": "",
      "hide-overlay": "",
      "light": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "absolute": "",
      "clipped": "",
      "mini-variant": "",
      "light": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, _vm._l((_vm.buys), function(buy) {
    return _c('a', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": buy.img
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:right",
      value: ({
        html: 'Book menu'
      }),
      expression: "{ html: 'Book menu' }",
      arg: "right"
    }],
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'Share on LinkedIn'
      }),
      expression: "{ html: 'Share on LinkedIn' }",
      arg: "bottom"
    }],
    attrs: {
      "onclick": "window.open('https://www.linkedin.com/shareArticle?mini=true&amp;url=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835&amp;title=A%20Pocket%20Guide%20to%20Combining%20typefaces&amp;summary=Get%20%23Free%20%23Sample%20of%20A%20Pocket%20Guide%20to%20Combining%20typefaces%20-%20%0D%0ABestselling%20author%20and%20erstwhile%20musician%20Harper%20Ellison%20started%20running%20from%20his%20troubled%20past%20before%20he%20graduated%20high%20school.%20When%20his%20sister%20tracks%20him%20down%20ten%20years%20later%2C%20Harper...&amp;source=LinkedIn','_blank')"
    }
  }, [_c('v-icon', [_vm._v("fa-linkedin")])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'Share on Twitter'
      }),
      expression: "{ html: 'Share on Twitter' }",
      arg: "bottom"
    }],
    attrs: {
      "onclick": "window.open('https://twitter.com/intent/tweet?text=Get%20%23Free%20%23Sample%20of%20A%20Pocket%20Guide%20to%20Combining%20typefaces%20&amp;url=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835&amp;via=textcafecom','_blank')"
    }
  }, [_c('v-icon', [_vm._v("fa-twitter")])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'Share on Facebook'
      }),
      expression: "{ html: 'Share on Facebook' }",
      arg: "bottom"
    }],
    attrs: {
      "onclick": "window.open('https://www.facebook.com/sharer/sharer.php?u=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835','_blank')"
    }
  }, [_c('v-icon', [_vm._v("fa-facebook")])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'Share on Tumblr'
      }),
      expression: "{ html: 'Share on Tumblr' }",
      arg: "bottom"
    }],
    attrs: {
      "onclick": "window.open('https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835&posttype=link&caption=Get%20%23Free%20%23Sample%20of%20A%20Pocket%20Guide%20to%20Combining%20typefaces%20-%20%0D%0ABestselling%20author%20and%20erstwhile%20musician%20Harper%20Ellison%20started%20running%20from%20his%20troubled%20past%20before%20he%20graduated%20high%20school.%20When%20his%20sister%20tracks%20him%20down%20ten%20years%20later%2C%20Harper...','_blank')"
    }
  }, [_c('v-icon', [_vm._v("fa-tumblr")])], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("shopping_basket")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(buy.title)
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("share")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "src": social.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(social.title)
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'Instructions'
      }),
      expression: "{ html: 'Instructions' }",
      arg: "bottom"
    }],
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("fa-info-circle")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Set application visuals'
      }),
      expression: "{ html: 'Set application visuals' }",
      arg: "left"
    }],
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6c823cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 20
// module chunks = 0